module.exports = __webpack_public_path__ + "static/img/YORK老师_孙源.bfaf499.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/YORK/YORK老师_孙源.png
// module id = 6Evw
// module chunks = 0